import { useToken } from '@chakra-ui/react';
import * as d3 from 'd3';
import React from 'react';

import { useColorModeValue } from 'toolkit/chakra/color-mode';

import { calculateContainerHeight } from './utils';

const ChartTooltipBackdrop = () => {
  const bgColor = useToken('colors', useColorModeValue('white', 'blackAlpha.900'));
  const borderColor = useToken('colors', useColorModeValue('defaultWhite.100', 'transparent'));

  return (
    <g>
      <defs>
        <filter id="tooltip-shadow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="1" stdDeviation="8" floodColor="rgba(0,0,0,0.05)"/>
          <feDropShadow dx="0" dy="1" stdDeviation="4" floodColor="rgba(0,0,0,0.05)"/>
        </filter>
      </defs>

      <rect
        className="ChartTooltip__backdrop"
        rx={ 12 }
        ry={ 12 }
        fill={ bgColor[0] }
        filter="url(#tooltip-shadow)"
        stroke={ borderColor[0] }
        strokeWidth={ 1 }
      />
    </g>
  );
};

export default React.memo(ChartTooltipBackdrop);

interface UseRenderBackdropParams {
  seriesNum: number;
  transitionDuration: number | null;
}

export function useRenderBackdrop(ref: React.RefObject<SVGGElement | null>, { seriesNum, transitionDuration }: UseRenderBackdropParams) {
  return React.useCallback((width: number, isIncompleteData: boolean) => {
    const height = calculateContainerHeight(seriesNum, isIncompleteData);

    if (transitionDuration) {
      d3.select(ref.current)
        .select('.ChartTooltip__backdrop')
        .transition()
        .duration(transitionDuration)
        .ease(d3.easeLinear)
        .attr('width', width)
        .attr('height', height);
    } else {
      d3.select(ref.current)
        .select('.ChartTooltip__backdrop')
        .attr('width', width)
        .attr('height', height);
    }
  }, [ ref, seriesNum, transitionDuration ]);
}
